<h1 mat-dialog-title>Sprint overlaps with Sprint:</h1>
<div mat-dialog-content>
  <h2>{{data.name}}</h2>
  <h4>Start Date:</h4>
  <p>{{data.startDate | slice : 0 : 10}}</p>
  <h4>End Date:</h4>
  <p>{{data.endDate | slice : 0 : 10}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="closeDialog()">OK</button>
</div>